module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cf_gaseosas_pet_1,75_ccl.75468cb8.png";